import Grid from "@mui/material/Grid2";
import { useState, lazy, Suspense } from "react";
import { styled } from "@mui/material/styles";
import {
  Paper,
  Box,
  Button,
  Stack,
  Typography,
  IconButton,
  TextField,
  Tooltip,
  Chip,
  useMediaQuery,
} from "@mui/material";
import { getColorForIndex, maxLength, scrollToTop } from "../../utilities";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
// import OffersAndDeals from "../../components/home/OffersAndDeals";
import {
  addComboToCart,
  addToCart,
  getProductDetails,
  getPincodeCheck,
  shareProduct,
} from "../../utilities/service";
import { useLocation, useNavigate, useParams } from "react-router";
import { CommonSection } from "../../components/common/CommonSection";
import BreadcrumbNavigation from "../../components/common/BreadcrumbNavigation";
import useApiQuery from "../../hooks/useApiQuery";
import Ratings from "../../components/common/Ratings";
import { useEffect } from "react";
import AnimatedDelivery from "./AnimatedDelivery";
import FastDeliveryIcon from "./../../assets/icons/fast-shipping.png";
import VariationButton from "./VariationButton";
import ProductQuantityButtons from "./ProductQuantityButtons";
import { useAuth } from "../../hooks/AuthContext";
import { toast } from "react-toastify";
import useApiMutation from "../../hooks/useApiMutation";
import ProductDetailsSkeleton from "./skeleton/ProductDetailsSkeleton";
import { motion } from "framer-motion";
import PageWrapper from "../../animations/PageWrapper";
import SuggestionProduct from "./suggestionProduct/SuggestionProduct";
import CakeDesignerDialog from "../home/customDesign/CakeDesignerDialog";
import { Lightning, ThumbsUp, Heart } from "@phosphor-icons/react";
import { useTheme } from "@emotion/react";
import VegNonVegTag from "../../components/common/VegNonVegTag";
import axios from 'axios';
const OffersAndDeals = lazy(
  () => import("../../components/home/OffersAndDeals"),
);

const MotionImage = motion.img;

const ThumbnailImage = styled("img")(({ theme, index }) => ({
  backgroundColor: getColorForIndex(index),
  padding: theme.spacing(1),
  textAlign: "center",
  width: "100%",
  height: "100%",
  borderRadius: "4px",
  cursor: "pointer",
  border: "2px solid transparent",
  transition: "border-color 0.2s ease, box-shadow 0.2s ease",
  "&:hover": {
    borderColor: "var(--primary-red-base)",
    boxShadow: "0 0 8px rgba(196, 154, 39, 0.3)",
  },
}));
export const PreviewImage = styled(MotionImage)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
  width: "100%",
  height: "100%",
  [theme.breakpoints.down("md")]: {
    width: "75%",
  },
}));
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));
export const Tag = styled("span")(({ theme }) => ({
  textTransform: "capitalize",
  fontWeight: "500",
  fontSize: "14px",
  lineHeight: "125%",
  color: "var(--primary-red-300)",
  textAlign: "left",
  background: "var(--primary-red-100)",
  padding: "5px 10px",
  borderRadius: "4px",
  width: "fit-content",
}));
const CakeName = styled("h3")(({ theme }) => ({
  margin: 0,
  fontWeight: 700,
  fontSize: "28px",
  lineHeight: "150%",
  color: "var(--neutral-black)",
  textAlign: "left",
  textTransform: "capitalize",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  position: "relative",
  paddingBottom: "10px",
  "&::after": {
    content: '""',
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "44px",
    height: "3px",
    borderRadius: "2px",
    background: "var(--primary-red-base)",
  },
  [theme.breakpoints.down("lg")]: {
    fontSize: "24px",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "24px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "20px",
  },
}));
const Stars = styled("div")(({ theme }) => ({
  color: "#FFB800",
}));
const RatingNumber = styled("span")(({ theme }) => ({
  fontWeight: 600,
  fontSize: "18px",
  color: "var(--neutral-black)",
}));
const ReviewCount = styled("span")(({ theme }) => ({
  fontWeight: 400,
  fontSize: "18px",
  color: "var(--neutral-700)",
}));

const ProductDetails = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const navigate = useNavigate();
  const { productName, id, varIndex = 0 } = useParams();
  const { user, setUser, setLoginDialogOpen } = useAuth();
  const location = useLocation();
  const fallbackImage = location.state?.fallbackImage;
  const [dialogOpen, setDialogOpen] = useState(false);
  const [uploadedCakeImageBase, setUploadedCakeImageBase] = useState(null);
  const [activeTab, setActiveTab] = useState();
  const [activeBulkTab, setActiveBulkTab] = useState();
  const [activeChip, setActiveChip] = useState("");
  const [variationIndex, setVariationIndex] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [variant, setVariant] = useState("0.5 Kg");
  const [pincode, setpincode] = useState("");
  const [previewImage, setPreviewImage] = useState(null);
  const [cakeType, setCakeType] = useState("EGG");
  const [firstTime, setFirstTime] = useState(true);
  const [minimumQuantity, setMinimumQuantity] = useState();
  const [shouldNavigateToCart, setShouldNavigateToCart] = useState(false);

  const increase = () => setQuantity((q) => q + 1);
  const decrease = () => setQuantity((q) => (q > 1 ? q - 1 : 1));
  const { data, error, isLoading } = useApiQuery({
    queryKey: ["productDetails", id, user?.customer_id, user?.region_id],
    queryFn: () =>
      getProductDetails(
        id,
        user?.customer_id || "null",
        user?.region_id || "null",
      ),
  });

  const offers = data?.data?.sections?.[1];
  const productDetails = data?.data?.product;
  const shapeName = Number(productDetails?.shape_id);
  const [pinResult, setPinResult] = useState("");
  const [isPincodeValid, setIsPincodeValid] = useState(false);
  const [selectedFlavourIndex, setSelectedFlavourIndex] = useState(0);
  const fastDelivery = productDetails?.fast_delivery;

  const imageArray = productDetails?.images;
  const productNameTitle = productDetails?.product_name;
  const categoryName = data?.data?.product?.category?.category_name;
  const categorySlug = data?.data?.product?.category?.category_slug;
  const showMsgOnCakeFlag = data?.data?.product?.category?.show_msg_on_cake;

  const unit = productDetails?.unit?.unit_name;
  const variationWeightId = productDetails?.variation[varIndex]?.weight_id;
  const weightIndex = productDetails?.weight_ids?.findIndex(
    (item) => item?.id == variationWeightId,
  );
  const weightId = productDetails?.weight_ids[weightIndex]?.id;
  const flavourId = productDetails?.flavour[selectedFlavourIndex]?.id;
  const flavour = productDetails?.flavour[selectedFlavourIndex]?.itemName;
  const notDefaultFlavour = flavour !== "Default" ? true : false;
  const hasMultipleFlavours =
    !!shapeName && productDetails?.flavour?.length > 0;
  const ratings = parseFloat(productDetails?.ratings);
  const bulkData = productDetails?.bulk?.bulk_price;
  const isBulkVariant =
    bulkData?.length > 0 &&
    bulkData?.find((item) => item?.weight_id == activeTab);
  let minimumQty = isBulkVariant?.min_quantity;

  let discountPrice = 0;
  let originalPrice = 0;
  let discountPercent = 0;
  let save = 0;
  let discountPriceOnly = 0;

  useEffect(() => {
    if (productDetails) {
      const egglessP =
        productDetails?.variation[variationIndex]?.eggLessOriginalPrice;
      const eggP = productDetails?.variation[variationIndex]?.eggOriginalPrice;
      if (+egglessP == 0 && +eggP > 0) {
        setCakeType("EGG");
      } else if (+egglessP > 0 && +eggP == 0) {
        setCakeType("EGGLESS");
      }

      if (firstTime) {
        // setFirstTime(false);
        setVariationIndex(varIndex);
        setActiveTab(weightId);
      }
      scrollToTop();
    }
  }, [productDetails, variationIndex, cakeType, varIndex]);

  if (isBulkVariant) {
    const bulkPriceData = bulkData?.find((item) => item?.id == activeBulkTab);
    const minimumQty = bulkPriceData?.min_quantity;
    if (quantity >= minimumQty) {
      if (cakeType === "EGGLESS") {
        discountPrice = bulkPriceData?.eggless_price;
        discountPriceOnly = discountPrice;
        originalPrice = bulkPriceData?.eggless_price;
      } else {
        discountPrice = bulkPriceData?.egg_price;
        discountPriceOnly = discountPrice;
        originalPrice = bulkPriceData?.egg_price;
      }
    } else {
      if (cakeType === "EGGLESS") {
        discountPrice =
          productDetails?.variation[variationIndex]?.eggLessOriginalPrice;
        discountPriceOnly = discountPrice;
        originalPrice = productDetails?.variation[variationIndex]?.eggLess;
        discountPercent =
          productDetails?.variation[variationIndex]?.discountPercent;
        save = productDetails?.variation[variationIndex]?.eggLessDiscountPrice;
      } else {
        discountPrice =
          productDetails?.variation[variationIndex]?.eggOriginalPrice;
        discountPriceOnly = discountPrice;
        originalPrice = productDetails?.variation[variationIndex]?.egg;
        discountPercent =
          productDetails?.variation[variationIndex]?.discountPercent;
        save = productDetails?.variation[variationIndex]?.eggDiscountPrice;
      }
    }
  } else {
    if (cakeType === "EGGLESS") {
      discountPrice =
        productDetails?.variation[variationIndex]?.eggLessOriginalPrice;
      discountPriceOnly = discountPrice;
      originalPrice = productDetails?.variation[variationIndex]?.eggLess;
      discountPercent =
        productDetails?.variation[variationIndex]?.discountPercent;
      save =
        productDetails?.variation[variationIndex]?.eggLessDiscountPrice *
        quantity;
    } else {
      discountPrice =
        productDetails?.variation[variationIndex]?.eggOriginalPrice;
      discountPriceOnly = discountPrice;
      originalPrice = productDetails?.variation[variationIndex]?.egg;
      discountPercent =
        productDetails?.variation[variationIndex]?.discountPercent;
      save =
        productDetails?.variation[variationIndex]?.eggDiscountPrice * quantity;
    }
  }

  let preparationHours =
    productDetails?.variation[variationIndex]?.egg_preparation;
  if (preparationHours == 0) {
    preparationHours =
      productDetails?.variation[variationIndex]?.eggless_preparation;
  }

  const careInstruction = productDetails?.product_description
    ?.split(/\[BRK\]\s*/)
    .map((item) => item.trim());
  const description = productDetails?.short_description
    ?.split(/\[BRK\]\s*/)
    .map((item) => item.trim());
  let unitPrice = discountPrice;
  //Calculated Price with quantity
  if (productDetails?.combo_price > 0) {
    const unitPrice = productDetails?.combo_price;

    const originalComboProductPrice =
      productDetails?.combo_product_details?.reduce(
        (total, item) =>
          total +
          (+item?.variation?.[0]?.egg > 0
            ? +item?.variation?.[0]?.egg
            : +item?.variation?.[0]?.eggLess || 0),
        0,
      );

    // ✅ Only this line changed — addon added to original price only
    const addonTotalPrice =
      productDetails?.combo_addon_details?.reduce(
        (total, addon) => total + (+addon?.price || 0),
        0,
      ) || 0;

    discountPrice = (+unitPrice * quantity).toString();
    originalPrice = (
      (+originalComboProductPrice + addonTotalPrice) *
      quantity
    ).toString();
  } else {
    // const unitPrice = discountPrice;
    discountPrice = (+discountPrice * quantity).toString();
    originalPrice = (+originalPrice * quantity).toString();
  }
  // Handle Egg and Eggless availability
  let cakeAndCakeless = false;
  if (
    productDetails?.variation[variationIndex]?.eggLessOriginalPrice > 0 &&
    productDetails?.variation[variationIndex]?.eggOriginalPrice > 0
  ) {
    cakeAndCakeless = true;
  }

  const handleQuantityChange = (quantity) => {
    setQuantity(quantity);
    if (bulkData?.length > 0) {
      const matchingPrice = bulkData?.find(
        (item) =>
          quantity >= item?.min_quantity && quantity <= item?.max_quantity,
      );
      if (matchingPrice) {
        minimumQty = quantity;
        setMinimumQuantity(quantity);
        setActiveBulkTab(matchingPrice.id);
      } else {
        setActiveBulkTab(null);
      }
    }
  };

  const handleWeightChange = (weightId) => {
    const variationIndex = productDetails?.variation?.findIndex(
      (varItem) => varItem?.weight_id === weightId,
    );
    setFirstTime(false);
    if (variationIndex >= 0) {
      setVariationIndex(variationIndex);
    }
    setActiveTab(weightId);
  };

  // Open with shape
  const handleUploadClick = () => {
    if (!shapeName) {
      toast.error("No shape ID available");
      return;
    }
    setDialogOpen(true);
  };
  //Pincode checking

  const handleCheckPincode = async () => {
    if (pincode.length !== 6) {
      setPinResult("Enter valid 6-digit pincode");
      setIsPincodeValid(false);
      return;
    }

    try {
      console.log("Checking:", pincode);

      const res = await getPincodeCheck(pincode);
      console.log("API Response:", res);

      if (res.error === true || !res.data) {
        setPinResult("Invalid pincode");
        setIsPincodeValid(false);
        return;
      }

      const { State: state, District: district } = res.data;

      if (state === "Tamil Nadu") {
        setIsPincodeValid(true);
        setPinResult(`✔ Serviceable — ${district}, ${state}`);
      } else {
        setIsPincodeValid(false);
        setPinResult(`❌ Not in Tamil Nadu — State: ${state}`);
      }
    } catch (err) {
      console.log("ERROR:", err);
      setIsPincodeValid(false);
      setPinResult("Error checking pincode");
    }
  };

  const parseBoldText = (text, index) => {
    const parts = text.split(/(\*[^\*]+\*)/);
    let isFirstPart = true;
    return (
      <li key={index}>
        {" "}
        {/* <--  key applied here */}
        <Typography
          variant="body2"
          sx={{
            fontWeight: 400,
            fontSize: { xs: "12px", lg: "16px" },
            color: "var(--neutral-800)",
            textAlign: "left",
          }}
        >
          {parts.map((part, partIndex) => {
            if (part.match(/\*[^\*]+\*/)) {
              return (
                <Typography
                  key={`bold-${partIndex}`} //  key added for child Typography
                  component="span"
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  {part.replace(/\*/g, "")}
                </Typography>
              );
            }

            const formattedPart = isFirstPart ? ` ${part.trim()}` : part.trim();
            isFirstPart = false;
            return (
              <span key={`normal-${partIndex}`}>{formattedPart}</span> //  key added for normal text
            );
          })}
        </Typography>
      </li>
    );
  };
  const dataURLtoFile = (dataUrl, filename) => {
    const arr = dataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  useEffect(() => setMinimumQuantity(minimumQty), [minimumQty]);
  const buildFormData = (data) => {
    const formData = new FormData();

    for (const key in data) {
      const value = data[key];

      if (value instanceof File) {
        formData.append(key, value);
      } else if (typeof value === "object" && value !== null) {
        formData.append(key, JSON.stringify(value)); // stringify nested objects/arrays
      } else {
        formData.append(key, value);
      }
    }

    return formData;
  };
  const addToCartHandler = async (buyNow = false) => {
    // if (!pincode || pincode.trim() == ""){
    //   toast.error("Enter your Pincode");
    //   return;
    // }
    if (user?.customer_id) {
      if (buyNow) setShouldNavigateToCart(true);
      let param;
      if (productDetails?.combo_price > 0) {
        param = {
          customer_id: user?.customer_id,
          parent_id: id,
          combo_price: productDetails?.combo_price,
          product_quantity: quantity,
          pincode: pincode,
          product_variation: productDetails?.combo_product_details?.map(
            (item) => {
              return {
                ...item?.variation?.[variationIndex],
                product_id: item.id,
                isEggless: cakeType == "EGGLESS" ? 1 : 0,
              };
            },
          ),
        };
      } else {
        param = {
          customer_id: user?.customer_id,
          product_id: productDetails?.id,
          product_quantity: quantity,
          product_size_id: activeTab,
          product_total: discountPrice,
          product_price: originalPrice,
          product_discount_price: discountPriceOnly,
          flavour_id: flavourId,
          pincode: pincode,
          variation_ids:
            productDetails?.variation[variationIndex]?.variation_id,
          eggless: cakeType == "EGGLESS" ? 1 : 0,
          is_bulk_product: isBulkVariant?.id || 0,
        };
        if (uploadedCakeImageBase) {
          const imageFile = dataURLtoFile(
            uploadedCakeImageBase,
            "custom_image.png",
          );
          param.customer_refer_image = imageFile;
        }
      }
      const formData = buildFormData(param);
      mutate(formData);
    } else {
      setLoginDialogOpen(true);
    }
  };
  
const handleNativeShare = async () => {
  const slug = productDetails?.product_slug;

  // Get Laravel domain from axios baseURL (already configured)
  const laravelBase = axios.defaults.baseURL?.replace('/api', '');
  const shareUrl = `${laravelBase}share/${slug}`;

  try {
    const res = await shareProduct(slug);
    const shareTitle = res?.data?.title || productNameTitle;
    if (navigator.share) {
      navigator.share({ title: shareTitle, url: shareUrl });
    } else {
      navigator.clipboard.writeText(shareUrl);
      toast.success("Link copied!");
    }
  } catch (err) {
    if (navigator.share) {
      navigator.share({ title: productNameTitle, url: shareUrl });
    } else {
      navigator.clipboard.writeText(shareUrl);
      toast.success("Link copied!");
    }
  }
};

  const {
    mutate,
    isPending: postIsLoading,
    error: postError,
    data: postData,
  } = useApiMutation({
    mutationFn: (param) =>
      productDetails?.combo_price > 0
        ? addComboToCart(param)
        : addToCart(param),
    options: {
      onSuccess: (data, variables) => {
        if (!data?.error) {
          setUser((prev) => {
            return { ...prev, cartCount: data?.data?.cart_count };
          });
          toast.success(data?.message);
          if (shouldNavigateToCart) {
            setShouldNavigateToCart(false);
            setTimeout(() => navigate("/cart"), 500);
          }
        } else {
          toast.error(data?.message);
        }
      },
      onError: (error) => {
        console.log(error);
        toast.error(error?.message);
      },
    },
  });

  const bestSeller = productDetails?.product_tags?.best_selling == 1;
  const newArrival = productDetails?.product_tags?.new_product == 1;

  const loading = isLoading;
  const errorResult = error;

  if (loading) return <ProductDetailsSkeleton layoutId={`card-${id}`} />;
  if (errorResult) return <div>Error loading product details</div>;
  // console.log(imageArray);
  return (
    <PageWrapper>
      <motion.div layoutId={`card-${id}`}>
        {isLoading ? (
          <ProductDetailsSkeleton fallbackImage={fallbackImage} />
        ) : (
          <>
            <CommonSection sx={{ mt: 3 }}>
              <BreadcrumbNavigation
                items={[
                  { label: categoryName, path: `/listing/${categorySlug}` },
                  { label: productNameTitle },
                ]}
              />

              <Grid
                container
                spacing={5}
                rowGap={4}
                sx={{ mt: { xs: 2, sm: 3, md: 4 } }}
              >
                <Grid size={{ xs: 12, md: 6 }}>
                  <Box sx={{ position: "sticky", top: "136px" }}>
                    <Box sx={{ position: "relative" }}>
                      {(productDetails?.is_best_seller === 1 ||
                        productDetails?.is_featured === 1 ||
                        fastDelivery === 1) && (
                        <Box
                          sx={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            zIndex: 3,
                            overflow: "hidden",
                            maxWidth: "100%",
                          }}
                        >
                          <Chip
                            label="Curated"
                            size="small"
                            sx={{
                              fontSize: { xs: "11px", sm: "12px" },
                              background:
                                "linear-gradient(135deg, #C59A42 0%, #DAB76B 100%)",
                              fontWeight: 700,
                              color: "white",
                              borderRadius: "0px 4px 0px 4px",
                              padding: { xs: "1px", sm: "4px 8px" },
                              minWidth: { xs: "140px", sm: "160px" },
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              letterSpacing: "0.02em",
                              boxShadow: "0 10px 18px rgba(184, 132, 44, 0.18)",
                              "& .MuiChip-label": {
                                paddingLeft: "8px",
                                paddingRight: "8px",
                              },
                            }}
                          />
                        </Box>
                      )}
                    </Box>

                    <Grid container spacing={5}>
                      <Grid
                        size={{ xs: 12, md: 2.5 }}
                        sx={{ display: { xs: "none", md: "block" } }}
                      >
                        <Stack direction="column" spacing={2}>
                          {imageArray?.map((item, index) => (
                            <ThumbnailImage
                              onClick={() =>
                                setPreviewImage(item?.product_image)
                              }
                              src={item?.product_image}
                              alt={item?.product_image_id}
                              index={index}
                              key={index}
                            />
                          ))}

                          {Array.isArray(
                            productDetails?.combo_product_details,
                          ) &&
                            productDetails.combo_product_details.length > 0 &&
                            productDetails.combo_product_details.map(
                              (item, index) =>
                                item?.images?.[0]?.product_image && (
                                  <ThumbnailImage
                                    onClick={() =>
                                      setPreviewImage(
                                        item.images[0].product_image,
                                      )
                                    }
                                    src={item.images[0].product_image}
                                    alt={item.images[0].product_image_id}
                                    index={index}
                                    key={index}
                                  />
                                ),
                            )}

                          {/* ✅ Add addon thumbnails */}
                          {Array.isArray(productDetails?.combo_addon_details) &&
                            productDetails.combo_addon_details.length > 0 &&
                            productDetails.combo_addon_details.map(
                              (addon, index) =>
                                addon?.image && (
                                  <ThumbnailImage
                                    onClick={() => setPreviewImage(addon.image)}
                                    src={addon.image}
                                    alt={addon.product_name}
                                    index={
                                      index +
                                      (productDetails?.combo_product_details
                                        ?.length || 0)
                                    } // offset index
                                    key={`addon-${index}`}
                                  />
                                ),
                            )}
                        </Stack>
                      </Grid>
                      <Grid
                        size={{ xs: 12, md: 9.5 }}
                        gap={3}
                        sx={{ display: "flex", flexDirection: "column" }}
                      >
                        <Paper elevation={0} sx={{ textAlign: "center" }}>
                          {productDetails?.combo_price > 0 ? (
                            // Combo product - check if it has both veg and non-veg items
                            (() => {
                              const hasEggless =
                                productDetails?.combo_product_details?.some(
                                  (item) =>
                                    item?.variation?.[variationIndex]?.eggLess >
                                    0,
                                );
                              const hasEgg =
                                productDetails?.combo_product_details?.some(
                                  (item) =>
                                    item?.variation?.[variationIndex]?.egg > 0,
                                );

                              if (hasEggless && hasEgg) {
                                // Show both tags
                                return (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      margin: "8px 0px 0px 10px",
                                    }}
                                  >
                                    <VegNonVegTag
                                      isVeg={true}
                                      size={16}
                                      showLabel={false}
                                      cake={true}
                                    />
                                    <VegNonVegTag
                                      isVeg={false}
                                      size={16}
                                      showLabel={false}
                                      cake={true}
                                    />
                                  </Box>
                                );
                              } else if (hasEggless) {
                                // Show only veg tag
                                return (
                                  <Box sx={{ margin: "6px 0px 0px 8px" }}>
                                    <VegNonVegTag
                                      isVeg={true}
                                      size={16}
                                      showLabel={false}
                                      cake={true}
                                    />
                                  </Box>
                                );
                              } else {
                                // Show only non-veg tag
                                return (
                                  <Box sx={{ margin: "6px 0px 0px 8px" }}>
                                    <VegNonVegTag
                                      isVeg={false}
                                      size={16}
                                      showLabel={false}
                                      cake={true}
                                    />
                                  </Box>
                                );
                              }
                            })()
                          ) : (
                            // Regular product - show based on cakeType
                            <Box sx={{ margin: "6px 0px 0px 8px" }}>
                              <VegNonVegTag
                                isVeg={cakeType === "EGGLESS"}
                                size={16}
                                showLabel={false}
                                cake={true}
                              />
                            </Box>
                          )}
                          <PreviewImage
                            src={previewImage || imageArray?.[0]?.product_image}
                            alt={previewImage || imageArray?.[0]?.product_image}
                            transition={{ duration: 0.3 }}
                          />
                        </Paper>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                  <Box
                    sx={{
                      position: "relative",
                      display: "flex",
                      flexDirection: "column",
                      gap: { xs: 0.25, md: 2 },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        position: "sticky",
                        top: { xs: 65, sm: 96 },
                        backgroundColor: "#fff",
                        // pt: 1,
                        zIndex: 999,
                      }}
                    >
                      <CakeName>{productNameTitle}</CakeName>
                      {/* {notDefaultFlavour && <Tag>{flavour}</Tag>} */}
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        gap: { xs: 0.5, sm: 2, md: 3 },
                      }}
                    >
                      <Ratings
                        value={ratings}
                        styles={{ color: "#FF9900" }}
                        ratingNumberstyles={{
                          // fontSize: "18px",
                          color: "var(--neutral-black)",
                        }}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          marginLeft: "4px",
                          background: "rgba(244,239,230,0.72)",
                          border: "1px solid rgba(183,123,26,0.14)",
                          borderRadius: "999px",
                          px: 1.25,
                          py: 0.4,
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: 700,
                            fontSize: { xs: "11px", md: "12px" },
                            color: "#6B4A05",
                            letterSpacing: "0.06em",
                            textTransform: "uppercase",
                          }}
                        >
                          {fastDelivery === 1 ? "Ready" : `Prep ${+preparationHours} Hrs`}
                        </Typography>
                      </Box>
                      {bestSeller && (
                        <Chip
                          icon={
                            <ThumbsUp
                              size={isMobile ? 14 : 18}
                              color="#6B4A05"
                              weight="fill"
                            />
                          }
                          label={"Featured"}
                          size="small"
                          sx={{
                            fontSize: { xs: "8px", sm: "12px" },
                            background: "linear-gradient(135deg, #F6E7BD 0%, #EBCF86 100%)",
                            fontWeight: 700,
                            color: "#6B4A05",
                            borderRadius: "4px 4px 4px 0",
                            padding: { xs: "1px", sm: "6px 8px" },
                            minWidth: { xs: "auto", sm: "90px" },
                            zIndex: 999,
                            alignSelf: "center",
                            border: "1px solid rgba(183,123,26,0.18)",
                          }}
                        />
                      )}
                      {newArrival && (
                        <Chip
                          icon={
                            <Heart
                              size={isMobile ? 14 : 18}
                              color="#6B4A05"
                              weight="fill"
                            />
                          }
                          label={"New"}
                          size="small"
                          sx={{
                            fontSize: { xs: "8px", sm: "12px" },
                            background: "linear-gradient(135deg, #F7F1E7 0%, #EAD7B3 100%)",
                            fontWeight: 700,
                            color: "#6B4A05",
                            borderRadius: "4px",
                            padding: { xs: "1px", sm: "6px" },
                            zIndex: 999,
                            alignSelf: "center",
                            border: "1px solid rgba(183,123,26,0.18)",
                          }}
                        />
                      )}
                      {/* <ReviewCount>(120 Reviews)</ReviewCount> */}

                      <Stack
                        direction="row"
                        spacing={3}
                        sx={{ ml: "auto", alignItems: "center" }}
                      >
                        <Tooltip title="Share this product">
                          <IconButton onClick={handleNativeShare}>
                            <ShareOutlinedIcon className="product-details-util-icons" />
                          </IconButton>
                        </Tooltip>

                        {/* <FavoriteBorderOutlinedIcon className="product-details-util-icons" /> */}
                      </Stack>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: { xs: 2, sm: 2, md: 3 },
                      }}
                    >
                      <Box
                        className="product-details-variation"
                        sx={{
                          display: "flex",
                          gap: { xs: 2, sm: 10 },
                          mt: { xs: 0, sm: 1 },
                          flexDirection: { xs: "column", sm: "row" },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                          }}
                        >
                          <Typography
                            variant="h3"
                            sx={{
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "var(--neutral-700)",
                              textAlign: "left",
                            }}
                          >
                            Size
                          </Typography>
                          <Stack direction="row" spacing={2}>
                            {productDetails?.weight_ids.map((weight, index) => (
                              <VariationButton
                                index={index}
                                key={index}
                                weight={weight}
                                unit={unit}
                                btnColor="black"
                                textColor="white"
                                activeTab={activeTab}
                                setActiveTab={setActiveTab}
                                setVariationIndex={setVariationIndex}
                                handleWeightChange={handleWeightChange}
                              />
                            ))}
                          </Stack>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                          }}
                        >
                          <Typography
                            variant="h3"
                            sx={{
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "var(--neutral-700)",
                              textAlign: "left",
                            }}
                          >
                            Quantity
                          </Typography>
                          <ProductQuantityButtons
                            updatePrice={handleQuantityChange}
                            miniQty={minimumQuantity}
                            maxQty={(() => {
                              if (bulkData?.length > 0) {
                                const matchingBulk = bulkData?.find(
                                  (item) => item?.weight_id == activeTab,
                                );
                                if (matchingBulk) {
                                  // get the last/highest bulk tier max quantity
                                  const bulkForWeight = bulkData?.filter(
                                    (item) => item?.weight_id == activeTab,
                                  );
                                  return (
                                    bulkForWeight?.[bulkForWeight.length - 1]
                                      ?.max_quantity ?? null
                                  );
                                }
                              }
                              return null;
                            })()}
                          />
                        </Box>
                      </Box>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{ alignItems: "center" }}
                      >
                        {discountPrice > 0 && (
                          <Typography
                            variant="h3"
                            sx={{
                              fontWeight: 600,
                              fontSize: { xs: "22px", md: "30px", lg: "32px" },
                              lineHeight: "125%",
                              color: "var(--neutral-black)",
                              textAlign: "left",
                            }}
                          >
                            ₹{discountPrice}
                          </Typography>
                        )}
                        {isBulkVariant && discountPrice != unitPrice && (
                          <Typography
                            variant="h3"
                            sx={{
                              fontWeight: 600,
                              fontSize: { xs: "16px", lg: "24px" },
                              lineHeight: "125%",
                              color: "var(--neutral-black)",
                              textAlign: "left",
                            }}
                          >
                            {` / Unit Price ₹ ${unitPrice}`}
                          </Typography>
                        )}
                        {discountPrice != originalPrice && (
                          <>
                            <Typography
                              variant="h4"
                              sx={{
                                fontWeight: 500,
                                fontSize: {
                                  xs: "18px",
                                  md: "28px",
                                  lg: "30px",
                                },
                                lineHeight: "125%",
                                color: "var(--neutral-700)",
                                textAlign: "left",
                                textDecoration: "line-through",
                              }}
                            >
                              ₹{originalPrice}
                            </Typography>
                          </>
                        )}
                        {!productDetails?.combo_price &&
                          +discountPercent > 0 && (
                            <Typography
                              variant="h4"
                              sx={{
                                fontWeight: 500,
                                fontSize: {
                                  xs: "14px",
                                  md: "15px",
                                  lg: "16px",
                                },
                                lineHeight: "125%",
                                color: "#0cb67b",
                                textAlign: "center",
                                padding: "4px 12px",
                                backgroundColor: "rgba(8, 177, 118, 0.1)",
                                borderRadius: "4px",
                                display: "flex",
                                alignItems: "center",
                                marginTop: "4px !important",
                                marginBottom: "4px !important",
                                border: "1px solid #0cb67b",
                              }}
                            >
                              {discountPercent}% Off
                            </Typography>
                          )}

                        {!productDetails?.combo_price &&
                          +discountPercent > 0 &&
                          +save > 0 && (
                            <Typography
                              variant="h4"
                              sx={{
                                fontWeight: 500,
                                fontSize: {
                                  xs: "12px",
                                  md: "14px",
                                  lg: "18px",
                                },
                                lineHeight: "125%",
                                color: "var(--neutral-700)",
                                textAlign: "left",
                              }}
                            >
                              {`Save ₹${save}`}
                            </Typography>
                          )}
                      </Stack>
                      {hasMultipleFlavours && (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            mt: 1,
                          }}
                        >
                          <Typography
                            variant="h3"
                            sx={{
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "var(--neutral-700)",
                              textAlign: "left",
                            }}
                          >
                            Flavour
                          </Typography>
                          <Stack
                            direction="row"
                            spacing={1}
                            flexWrap="wrap"
                            useFlexGap
                          >
                            {productDetails?.flavour?.map((f, index) => (
                              <Chip
                                key={f.id}
                                label={f.itemName}
                                clickable
                                onClick={() => setSelectedFlavourIndex(index)}
                                sx={{
                                  fontWeight: 600,
                                  fontSize: "13px",
                                  borderRadius: "6px",
                                  border:
                                    selectedFlavourIndex === index
                                      ? "2px solid var(--primary-red-base)"
                                      : "2px solid var(--neutral-300)",
                                  backgroundColor:
                                    selectedFlavourIndex === index
                                      ? "var(--primary-red-100)"
                                      : "#fff",
                                  color:
                                    selectedFlavourIndex === index
                                      ? "var(--primary-red-400)"
                                      : "var(--neutral-700)",
                                }}
                              />
                            ))}
                          </Stack>
                        </Box>
                      )}
                      {(() => {
                        const bulkProductsBasedOnWeight = bulkData?.filter(
                          (item) => item?.weight_id == activeTab,
                        );
                        if (!bulkProductsBasedOnWeight?.length) return null;
                        return (
                          <Box sx={{ mt: 1 }}>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: 1,
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "16px",
                                  fontWeight: 600,
                                  color: "#4E4E4E",
                                }}
                              >
                                Bulk Orders
                              </Typography>
                              {bulkData?.[0]?.min_quantity > 1 && (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "10px",
                                      color: "#4E4E4E",
                                      fontWeight: 600,
                                    }}
                                  >
                                    Minimum Quantity:{" "}
                                    <Typography
                                      component="span"
                                      sx={{ fontSize: "12px", fontWeight: 700 }}
                                    >
                                      {bulkData?.[0]?.min_quantity}
                                    </Typography>
                                  </Typography>
                                </Box>
                              )}
                            </Box>
                            <Stack
                              direction="row"
                              spacing={2}
                              sx={{ overflowX: "auto", pb: 1 }}
                            >
                              {bulkProductsBasedOnWeight.map((item) => (
                                <Box
                                  key={item.id}
                                  onClick={() =>
                                    handleQuantityChange(item?.min_quantity)
                                  }
                                  sx={{
                                    cursor: "pointer",
                                    minWidth: "90px",
                                    border: "1px solid",
                                    borderColor:
                                      activeBulkTab === item?.id
                                        ? "#FF272F"
                                        : "#909090",
                                    borderRadius: "6px",
                                    backgroundColor:
                                      activeBulkTab === item?.id
                                        ? "#FFD4D5"
                                        : "#FFFFFF",
                                    padding: "6px ",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    transition: "all 0.2s ease",
                                    "&:hover": {
                                      borderColor: "#FF272F",
                                      backgroundColor: "#FFF0F0",
                                    },
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "14px",
                                      fontWeight:
                                        activeBulkTab === item?.id ? 700 : 600,
                                      color:
                                        activeBulkTab === item?.id
                                          ? "#FF272F"
                                          : "#1B1B1B",
                                    }}
                                  >
                                    ₹
                                    {cakeType === "EGGLESS"
                                      ? item?.eggless_price
                                      : item?.egg_price}
                                  </Typography>
                                  <Box
                                    sx={{
                                      mt: 0.5,
                                      backgroundColor:
                                        activeBulkTab === item?.id
                                          ? "#FFAAAB"
                                          : "#F0F0F0",
                                      borderRadius: "4px",
                                      px: 1,
                                      py: 0.25,
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        fontSize: "10px",
                                        color: "#4E4E4E",
                                      }}
                                    >
                                      Qty: {item?.min_quantity} -{" "}
                                      {item?.max_quantity ?? "N/A"}
                                    </Typography>
                                  </Box>
                                </Box>
                              ))}
                            </Stack>
                          </Box>
                        );
                      })()}
                      {/* {Array.isArray(productDetails?.combo_product_details) &&
                        productDetails?.combo_product_details?.length > 0 && (
                          <Box
                            sx={{
                              borderBottom: "1px solid var(--neutral-300)",
                              mb: 3,
                              pb: 2,
                              maxWidth: "550px",
                            }}
                          >
                            <Typography
                              variant="h4"
                              sx={{
                                fontWeight: 600,
                                fontSize: "16px",
                                color: "var(--neutral-800)",
                                mb: 3,
                                borderBottom: "1px solid var(--neutral-300)",
                                pb: 2,
                                textAlign: "left",
                              }}
                            >
                              Product Details
                            </Typography>

                            {productDetails?.combo_product_details?.map(
                              (comboItem, index) => {
                                const comboPrice =
                                  comboItem?.variation?.[variationIndex];
                                if (
                                  !comboItem?.images?.[0]?.product_image ||
                                  !comboItem?.product_name ||
                                  !comboPrice
                                ) {
                                  return null;
                                }

                                return (
                                  <Stack
                                    direction="row"
                                    spacing={2}
                                    alignItems="center"
                                    sx={{ mb: 1 }}
                                    key={index}
                                  >
                                    <Box
                                      sx={{
                                        width: 56,
                                        height: 56,
                                        borderRadius: 2,
                                        overflow: "hidden",
                                        border: "1px solid var(--neutral-200)",
                                        mr: 2,
                                        flexShrink: 0,
                                      }}
                                    >
                                      <img
                                        src={comboItem.images[0].product_image}
                                        alt={
                                          comboItem.images[0]
                                            .product_image_id || "combo image"
                                        }
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover",
                                        }}
                                      />
                                    </Box>

                                    <Box sx={{ flexGrow: 1 }}>
                                      <Typography
                                        variant="body1"
                                        sx={{
                                          fontWeight: 500,
                                          fontSize: "15px",
                                          color: "var(--neutral-black)",
                                          textAlign: "left",
                                          display: "flex",
                                          flexDirection: "row",
                                          gap: 2,
                                        }}
                                      >
                                        {comboItem.product_name}
                                        <VegNonVegTag
                                          isVeg={comboPrice?.eggLess > 0}
                                          size={16}
                                          showLabel={false}
                                          cake={true}
                                        />
                                      </Typography>
                                    </Box>

                                    <Typography
                                      variant="body1"
                                      sx={{
                                        fontWeight: 500,
                                        fontSize: "15px",
                                        color: "var(--neutral-black)",
                                      }}
                                    >
                                      ₹{" "}
                                      {comboPrice.egg > 0
                                        ? comboPrice.egg * quantity
                                        : comboPrice.eggLess * quantity}
                                    </Typography>
                                  </Stack>
                                );
                              }
                            )}
                          </Box>
                        )} */}
                      {/* EXISTING - combo_product_details */}
                      {Array.isArray(productDetails?.combo_product_details) &&
                        productDetails?.combo_product_details?.length > 0 && (
                          <Box
                            sx={{
                              borderBottom: "1px solid var(--neutral-300)",
                              mb: 3,
                              pb: 2,
                              maxWidth: "550px",
                            }}
                          >
                            <Typography
                              variant="h4"
                              sx={{
                                fontWeight: 600,
                                fontSize: "16px",
                                color: "var(--neutral-800)",
                                mb: 3,
                                borderBottom: "1px solid var(--neutral-300)",
                                pb: 2,
                                textAlign: "left",
                              }}
                            >
                              Product Details
                            </Typography>

                            {productDetails?.combo_product_details?.map(
                              (comboItem, index) => {
                                const comboPrice =
                                  comboItem?.variation?.[variationIndex];
                                if (
                                  !comboItem?.images?.[0]?.product_image ||
                                  !comboItem?.product_name ||
                                  !comboPrice
                                )
                                  return null;
                                return (
                                  <Stack
                                    direction="row"
                                    spacing={2}
                                    alignItems="center"
                                    sx={{ mb: 1 }}
                                    key={index}
                                  >
                                    <Box
                                      sx={{
                                        width: 56,
                                        height: 56,
                                        borderRadius: 2,
                                        overflow: "hidden",
                                        border: "1px solid var(--neutral-200)",
                                        mr: 2,
                                        flexShrink: 0,
                                      }}
                                    >
                                      <img
                                        src={comboItem.images[0].product_image}
                                        alt={
                                          comboItem.images[0]
                                            .product_image_id || "combo image"
                                        }
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover",
                                        }}
                                      />
                                    </Box>
                                    <Box sx={{ flexGrow: 1 }}>
                                      <Typography
                                        variant="body1"
                                        sx={{
                                          fontWeight: 500,
                                          fontSize: "15px",
                                          color: "var(--neutral-black)",
                                          textAlign: "left",
                                          display: "flex",
                                          flexDirection: "row",
                                          gap: 2,
                                        }}
                                      >
                                        {comboItem.product_name}
                                        <VegNonVegTag
                                          isVeg={comboPrice?.eggLess > 0}
                                          size={16}
                                          showLabel={false}
                                          cake={true}
                                        />
                                      </Typography>
                                    </Box>
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        fontWeight: 500,
                                        fontSize: "15px",
                                        color: "var(--neutral-black)",
                                      }}
                                    >
                                      ₹{" "}
                                      {comboPrice.egg > 0
                                        ? comboPrice.egg * quantity
                                        : comboPrice.eggLess * quantity}
                                    </Typography>
                                  </Stack>
                                );
                              },
                            )}

                            {/* ✅ ADD THIS BLOCK — combo_addon_details */}
                            {Array.isArray(
                              productDetails?.combo_addon_details,
                            ) &&
                              productDetails.combo_addon_details.length > 0 &&
                              productDetails.combo_addon_details.map(
                                (addon, index) => {
                                  if (!addon?.product_name) return null;
                                  const addonTotal = +addon.price * quantity;
                                  return (
                                    <Stack
                                      key={`addon-${index}`}
                                      direction="row"
                                      spacing={2}
                                      alignItems="center"
                                      sx={{ mb: 1, mt: 1 }}
                                    >
                                      {/* Image */}
                                      <Box
                                        sx={{
                                          width: 56,
                                          height: 56,
                                          borderRadius: 2,
                                          overflow: "hidden",
                                          border:
                                            "1px solid var(--neutral-200)",
                                          mr: 2,
                                          flexShrink: 0,
                                          backgroundColor: "#f8f8f8",
                                        }}
                                      >
                                        {addon.image ? (
                                          <img
                                            src={addon.image}
                                            alt={addon.product_name}
                                            style={{
                                              width: "100%",
                                              height: "100%",
                                              objectFit: "cover",
                                            }}
                                          />
                                        ) : (
                                          <Box
                                            sx={{
                                              width: "100%",
                                              height: "100%",
                                              backgroundColor: "#eee",
                                            }}
                                          />
                                        )}
                                      </Box>

                                      {/* Name + qty label */}
                                      <Box sx={{ flexGrow: 1 }}>
                                        <Typography
                                          variant="body1"
                                          sx={{
                                            fontWeight: 500,
                                            fontSize: "15px",
                                            color: "var(--neutral-black)",
                                            textAlign: "left",
                                          }}
                                        >
                                          {addon.product_name}
                                        </Typography>
                                        {/* <Typography
                                            variant="body2"f
                                            sx={{
                                              fontSize: "12px",
                                              color: "var(--neutral-500)",
                                              mt: 0.5,
                                            }}
                                          >
                                            Qty: {quantity}
                                          </Typography> */}
                                      </Box>

                                      {/* Price */}
                                      <Typography
                                        variant="body1"
                                        sx={{
                                          fontWeight: 500,
                                          fontSize: "15px",
                                          color: "var(--neutral-black)",
                                        }}
                                      >
                                        ₹ {addonTotal}
                                      </Typography>
                                    </Stack>
                                  );
                                },
                              )}
                          </Box>
                        )}
                      {user?.region_id == 27 && (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                            mt: 2,
                          }}
                        >
                          <Typography
                            variant="h3"
                            sx={{
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "var(--neutral-700)",
                              textAlign: "left",
                            }}
                          >
                            Enter Zip Code{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Typography>

                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: { xs: "wrap", sm: "nowrap" },
                              alignItems: "center",
                              gap: 2,
                              backgroundColor: "#f9f9f9",
                              borderRadius: "8px",
                              padding: "10px 14px",
                              border: "1px solid var(--neutral-200)",
                              width: "100%",
                            }}
                          >
                            {/* LEFT — PINCODE FIELD */}
                            <TextField
                              placeholder="Pincode"
                              variant="standard"
                              InputProps={{
                                disableUnderline: true,
                                style: { fontSize: "14px" },
                              }}
                              value={pincode}
                              onChange={(e) => {
                                const val = e.target.value.replace(/\D/g, "");
                                if (val.length <= 6) setpincode(val);
                              }}
                              sx={{
                                width: { xs: "100%", sm: "80px" },
                              }}
                            />

                            {/* CENTER MESSAGE */}
                            <Box
                              sx={{
                                flex: { xs: "1 1 100%", sm: 1 },
                                textAlign: "center",
                                mt: { xs: 1, sm: 0 },
                              }}
                            >
                              {pinResult && (
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    color: pinResult.includes("✔")
                                      ? "green"
                                      : "red",
                                    whiteSpace: "nowrap",
                                    textAlign: "left",
                                  }}
                                >
                                  {pinResult}
                                </Typography>
                              )}
                            </Box>

                            {/* RIGHT — CHECK BUTTON */}
                            <Button
                              variant="contained"
                              size="small"
                              onClick={handleCheckPincode}
                              sx={{
                                width: { xs: "100%", sm: "auto" },
                              }}
                            >
                              Check
                            </Button>
                          </Box>
                        </Box>
                      )}

                      {/* <Grid container spacing={3}>
                        {shapeName ? (
                          <>
                            <Grid size={12}>
                              <Button
                                onClick={() => handleUploadClick()}
                                variant="contained"
                                sx={{
                                  py: 1.5,
                                  fontSize: "16px",
                                  width: "100%",
                                }}
                              >
                                Personalize
                              </Button>
                            </Grid>
                          </>
                        ) : (
                          <>
                            <Grid size={6}>
                              <Button
                                onClick={() => addToCartHandler()}
                                variant="outlined"
                                sx={{
                                  py: 1.5,
                                  fontSize: "16px",
                                  width: "100%",
                                }}
                              >
                                Add to cart
                              </Button>
                            </Grid>
                            <Grid size={6}>
                              <Button
                                onClick={() => addToCartHandler(true)}
                                variant="contained"
                                sx={{
                                  py: 1.5,
                                  fontSize: "16px",
                                  width: "100%",
                                }}
                              >
                                Buy now
                              </Button>
                            </Grid>
                          </>
                        )}
                      </Grid> */}
                      <Grid container spacing={3}>
                        {shapeName ? (
                          <>
                            <Grid size={12}>
                              <Button
                                onClick={handleUploadClick}
                                variant="contained"
                                sx={{
                                  py: 1.5,
                                  fontSize: "16px",
                                  width: "100%",
                                }}
                                disabled={
                                  user?.region_id == 27 && !isPincodeValid
                                }
                              >
                                Personalize
                              </Button>
                            </Grid>
                          </>
                        ) : (
                          <>
                            <Grid size={6}>
                              <Button
                                onClick={() => addToCartHandler()}
                                variant="outlined"
                                sx={{
                                  py: 1.5,
                                  fontSize: "16px",
                                  width: "100%",
                                }}
                                disabled={
                                  user?.region_id == 27 && !isPincodeValid
                                }
                              >
                                Add to cart
                              </Button>
                            </Grid>

                            <Grid size={6}>
                              <Button
                                onClick={() => addToCartHandler(true)}
                                variant="contained"
                                sx={{
                                  py: 1.5,
                                  fontSize: "16px",
                                  width: "100%",
                                }}
                                disabled={
                                  user?.region_id == 27 && !isPincodeValid
                                }
                              >
                                Buy now
                              </Button>
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </Box>
                  </Box>
                  <Grid size={12} sx={{ mt: 4 }}>
                    <Typography
                      variant="h4"
                      sx={{
                        fontWeight: 600,
                        fontSize: { xs: "14px", lg: "16px" },
                        color: "var(--neutral-800)",
                        textAlign: "left",
                        mb: 1,
                      }}
                    >
                      Product Description
                    </Typography>
                    <ul
                      style={{
                        gap: "12px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {description &&
                        description.map((item, index) =>
                          parseBoldText(item?.trim(), index),
                        )}
                    </ul>

                    <Typography
                      variant="h4"
                      sx={{
                        fontWeight: 600,
                        fontSize: { xs: "14px", lg: "16px" },
                        color: "var(--neutral-800)",
                        textAlign: "left",
                        mb: 1,
                        mt: 4,
                      }}
                    >
                      Care Instructions
                    </Typography>

                    <ul
                      style={{
                        margin: 0,
                        paddingLeft: "2rem",
                        gap: "12px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {careInstruction.map((item, index) =>
                        parseBoldText(item?.trim(), index),
                      )}
                    </ul>
                  </Grid>
                </Grid>
              </Grid>

              <CakeDesignerDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                cakeTemplateProp={shapeName}
                onSubmitImage={(image) => setUploadedCakeImageBase(image)}
                addToCartHandler={addToCartHandler}
                uploadedCakeImageBase={uploadedCakeImageBase}
              />
              <SuggestionProduct productId={id} />
            </CommonSection>
            <Suspense fallback={null}>
              <OffersAndDeals data={offers} />
            </Suspense>
          </>
        )}
      </motion.div>
    </PageWrapper>
  );
};

export default ProductDetails;
